import React from 'react';

const FormInput = ({ label, type = "text", placeholder, value, onChange, required }) => {
  return (
    <div className="flex flex-col space-y-2">
      {label && <label className="font-medium">{label}</label>}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className="border rounded px-3 py-2"
      />
    </div>
  );
};

export default FormInput;